import {connect} from 'react-redux'
import Button from '@material-ui/core/Button';
import {addOptionCompare} from '../../redux/actions'
import {removeOptionCompare} from '../../redux/actions'

const CompareActionButton = (props) =>
  (<span className={"compare-action-button"}>
    {!(props.data && props.data.title in props.optionsCompare) &&
      <Button variant="outlined"  onClick={()=>{
        if(props.data){
          props.addOptionCompare(props.data);
        }
        }}>
        <i class="fas fa-plus" style={{fontSize:"8px", color:"green"}}></i>
        <i class="fas fa-balance-scale-left"></i>
      </Button>}
    {(props.data && props.data.title in props.optionsCompare) &&
      <Button variant="outlined"  onClick={()=>{
        if(props.data){
          props.removeOptionCompare(props.data);
        }
        }}>
        <i class="fas fa-minus" style={{fontSize:"8px", color:"red"}}></i>
        <i class="fas fa-balance-scale-left"></i>
      </Button>
    }
  </span>)




  const mapStateToProps = (state) => ({
    canShowAmazonLinks: state.canShowAmazonLinks,
    optionsCompare: state.options.optionsCompare,
  })

  const actionsCreators = {
    addOptionCompare:addOptionCompare,
    removeOptionCompare:removeOptionCompare,
  }
  export default connect(mapStateToProps, actionsCreators)(CompareActionButton)
